import * as React from "react";
import { useState } from "react";
import { translate } from "@js/common/helpers";
export var MoodboardForm = function (_a) {
    var moodboard = _a.moodboard, error = _a.error, onCreate = _a.onCreate;
    var _b = useState(moodboard.name), name = _b[0], setName = _b[1];
    function submit(event) {
        event.preventDefault();
        onCreate({
            name: name,
        });
    }
    return (React.createElement(React.Fragment, null,
        error &&
            React.createElement("div", { className: "alert-error" }, error),
        React.createElement("form", null,
            React.createElement("h3", { className: "text-center" }, translate('moodboard_quicksave.form.title')),
            React.createElement("div", { className: "mb-s" },
                React.createElement("label", null,
                    translate('moodboard_quicksave.form.name'),
                    ":"),
                React.createElement("input", { className: "form-control", value: name, onChange: function (event) { return setName(event.target.value); } })),
            React.createElement("div", { className: "text-center" },
                React.createElement("button", { className: "btn", onClick: submit }, translate('moodboard_quicksave.form.submit'))))));
};
